import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MATERIAL,
  MODEL_FORMAT_OUTPUT,
  POLYGON_TYPE,
  VIEW_TYPE,
} from 'Pods/ThreeDStudio/Store/constants'

const MATERIAL_MODE = {
  PBR: 'PBR',
  SHADED: 'shaded',
}

export default {
  "model_id": MODEL_ID.HYPER3D_IMAGE_TO_3D_GEN2,
  "provider": PROVIDER.HYPER3D,
  "action": ACTION.IMAGE_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
        // Multi-view limits from cgt-ai-studio-schema: accepted labelled views in the
        // provider's order, and how many images a multi-view run may carry.
        "multiView": {
          "viewTypes": [
            VIEW_TYPE.FRONT,
            VIEW_TYPE.LEFT,
            VIEW_TYPE.RIGHT,
            VIEW_TYPE.BACK,
            VIEW_TYPE.TOP,
            VIEW_TYPE.BOTTOM,
          ],
          "minItems": 2,
          "maxItems": 4,
        },
      },
      "multiview_input": {
        "type": "boolean",
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.PBR,
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.QUADRILATERAL,
      },
      "target_polycount": {
        "type": "integer",
        "oneOf": [
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
            },
            "then": {
              "properties": {
                "target_polycount": { "minimum": 10000, "maximum": 1000000, "default": 500000 },
              },
            },
          },
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
            },
            "then": {
              "properties": {
                "target_polycount": { "minimum": 10000, "maximum": 200000, "default": 100000 },
              },
            },
          },
        ],
      },
    },
    "required": ["input_image"],
    "allOf": [
      {
        "if": {
          "properties": { "material": { "enum": [MATERIAL.BASIC, MATERIAL.PBR] } },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.FBX },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": MATERIAL_MODE.PBR },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": MATERIAL_MODE.SHADED },
          },
        },
      },
    ],
  },
  "ui_schema": {},
  "active_if": {
    "properties": {
      "smart_low_poly": { "const": false },
      "ultra_mode": { "const": false },
      "material": { "enum": [MATERIAL.BASIC, MATERIAL.PBR] },
    },
  },
  "keyToConvert": [
    { "from": "polygon_type", "to": "topology" },
    { "from": "target_polycount", "to": "polycount" },
  ],
}
